import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 900px) {
    flex-direction: column;
  }

  @media (max-width: 450px) {
    gap: 0.5rem;
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background_white};
  margin: 3rem 0;
  width: 79%;
  padding-right: 1rem;

  h2 {
    color: ${({ theme }) => theme.colors.text};
    margin: 2rem 0 1rem 0;
    font-size: 1.3rem;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: auto;

    h1 {
      font-weight: 300;
      color: ${({ theme }) => theme.colors.tertiary_500};
      margin: 0;
      font-size: 18px;
    }

    .buttonsImport {
      display: flex;
      gap: 0.5rem;

      button {
        display: flex;
        align-items: center;
        color: ${({ theme }) => theme.colors.tertiary_500};
        text-decoration: underline;
        border: none;
        background: none;
        cursor: pointer;

        svg {
          padding: 0.5rem;
        }

        transition: opacity 0.2s;
        &:hover,
        &:focus {
          opacity: 0.55;
        }
      }
    }
  }

  .branchesList {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .branch {
    background: ${({ theme }) => theme.colors.background};
    width: 20%;
    min-width: 20rem;
    height: 6rem;
    border-radius: 1rem;
    padding: 0.8rem 1rem 1rem 0.8rem;

    .headerBranch {
      display: flex;
      justify-content: space-between;
      width: 100%;
      gap: 0.5rem;

      .containerName {
        width: 80%;

        .name {
          font-size: 20px;
          font-weight: 600;
          margin: 0;
          color: ${({ theme }) => theme.colors.primary};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .containerActions {
        width: 20%;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: end;
        gap: 0.5em;

        .MuiButton-root {
          min-width: 10%;
          width: 1rem;
          height: 1rem;
          padding: 0;
        }

        .edit {
          svg {
            height: 1.1rem;
            fill: ${({ theme }) => theme.colors.tertiary_500};
          }

          transition: opacity 0.2s;

          &:hover,
          &:focus {
            opacity: 0.55;
          }
        }

        .delete {
          svg {
            height: 1.1rem;
          }

          transition: opacity 0.2s;

          &:hover,
          &:focus {
            opacity: 0.55;
          }
        }
      }
    }

    .address {
      font-weight: 300;
      margin: 1rem 0;
      width: 100%;

      .street {
        display: flex;
        flex-direction: row;
        font-size: 1.1rem;
        color: ${({ theme }) => theme.colors.primary};

        .streetInfo {
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-left: 0.3rem;
          color: ${({ theme }) => theme.colors.gray_300};
          border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
        }
      }
    }
  }

  @media (max-width: 900px) {
    width: auto;
    margin-top: 0;
    padding: 1rem 1.5rem;
  }

  @media (min-width: 479px) and (max-width: 675px) {
    .branch {
      width: 15%;
      min-width: 15rem;
    }
  }

  @media (max-width: 480px) {
    padding: 0 1.5rem;

    .header {
      flex-direction: column;

      h1 {
        display: none;
      }

      .buttonsImport {
        flex-direction: column;
        width: 100%;
        gap: 0;

        button {
          padding: 0;

          svg {
            padding: 0.5rem;
          }
        }
      }
    }

    .branch {
      width: 100%;
      min-width: -webkit-fill-available;
      padding: 0.5rem;
    }
  }

  @media (max-width: 320px) {
    padding: 0.5rem;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  background: ${({ theme }) => theme.colors.background};
  border-radius: 1rem;
  margin-bottom: 2rem;

  .contentInfo {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    h3 {
      margin: 0;
      font-size: 1.2rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.primary};
    }

    p {
      margin: 0;
      font-size: 0.95rem;
      color: ${({ theme }) => theme.colors.gray_300};
    }
  }

  .add {
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 650px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 1.5rem;
    gap: 1.5rem;

    .add {
      width: 100%;
      justify-content: flex-start;
    }
  }
`;
